module.exports = __webpack_public_path__ + "img/tools-rank-hover.39d9fa29.png";